import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Pattern from './LoginSignupPattern.png';
import { useRef } from "react";
import { signup } from "./firebase";

const Signup = (props) => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();

    async function handleSubmit(e) {
        e.preventDefault();

        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            console.log("pass error")
            return setError('Passwords do not match');
        }

        try {
            setError('');
            setLoading(true);
            await signup(emailRef.current.value, passwordRef.current.value);
        } catch {
            console.log("error")
            setError('Failed to create an account');
        }

        setLoading(false);
    }

    

    return (
            <>
                <Navbar />
                <>

                    {/* This component uses @tailwindcss/forms

        yarn add @tailwindcss/forms
        npm install @tailwindcss/forms

        plugins: [require('@tailwindcss/forms')] */}


                    <section class="bg-white dark:bg-gray-900">
                        <div class="lg:grid lg:min-h-screen lg:grid-cols-12">
                            <aside
                                class="relative block h-16 lg:order-last lg:col-span-5 lg:h-full xl:col-span-6"
                            >
                                <img
                                    alt="Pattern"
                                    src={Pattern}
                                    class="absolute inset-0 h-full w-full object-cover"
                                />
                            </aside>

                            <main
                                aria-label="Main"
                                class="flex items-center justify-center px-8 py-8 sm:px-12 lg:col-span-7 lg:py-12 lg:px-16 xl:col-span-6"
                            >
                                <div class="max-w-xl lg:max-w-3xl">
                                    <a class="block text-blue-600" href="/">
                                        <span class="sr-only">Home</span>
                                        <svg
                                            class="h-8 sm:h-10"
                                            viewBox="0 0 28 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M0.41 10.3847C1.14777 7.4194 2.85643 4.7861 5.2639 2.90424C7.6714 1.02234 10.6393 0 13.695 0C16.7507 0 19.7186 1.02234 22.1261 2.90424C24.5336 4.7861 26.2422 7.4194 26.98 10.3847H25.78C23.7557 10.3549 21.7729 10.9599 20.11 12.1147C20.014 12.1842 19.9138 12.2477 19.81 12.3047H19.67C19.5662 12.2477 19.466 12.1842 19.37 12.1147C17.6924 10.9866 15.7166 10.3841 13.695 10.3841C11.6734 10.3841 9.6976 10.9866 8.02 12.1147C7.924 12.1842 7.8238 12.2477 7.72 12.3047H7.58C7.4762 12.2477 7.376 12.1842 7.28 12.1147C5.6171 10.9599 3.6343 10.3549 1.61 10.3847H0.41ZM23.62 16.6547C24.236 16.175 24.9995 15.924 25.78 15.9447H27.39V12.7347H25.78C24.4052 12.7181 23.0619 13.146 21.95 13.9547C21.3243 14.416 20.5674 14.6649 19.79 14.6649C19.0126 14.6649 18.2557 14.416 17.63 13.9547C16.4899 13.1611 15.1341 12.7356 13.745 12.7356C12.3559 12.7356 11.0001 13.1611 9.86 13.9547C9.2343 14.416 8.4774 14.6649 7.7 14.6649C6.9226 14.6649 6.1657 14.416 5.54 13.9547C4.4144 13.1356 3.0518 12.7072 1.66 12.7347H0V15.9447H1.61C2.39051 15.924 3.154 16.175 3.77 16.6547C4.908 17.4489 6.2623 17.8747 7.65 17.8747C9.0377 17.8747 10.392 17.4489 11.53 16.6547C12.1468 16.1765 12.9097 15.9257 13.69 15.9447C14.4708 15.9223 15.2348 16.1735 15.85 16.6547C16.9901 17.4484 18.3459 17.8738 19.735 17.8738C21.1241 17.8738 22.4799 17.4484 23.62 16.6547ZM23.62 22.3947C24.236 21.915 24.9995 21.664 25.78 21.6847H27.39V18.4747H25.78C24.4052 18.4581 23.0619 18.886 21.95 19.6947C21.3243 20.156 20.5674 20.4049 19.79 20.4049C19.0126 20.4049 18.2557 20.156 17.63 19.6947C16.4899 18.9011 15.1341 18.4757 13.745 18.4757C12.3559 18.4757 11.0001 18.9011 9.86 19.6947C9.2343 20.156 8.4774 20.4049 7.7 20.4049C6.9226 20.4049 6.1657 20.156 5.54 19.6947C4.4144 18.8757 3.0518 18.4472 1.66 18.4747H0V21.6847H1.61C2.39051 21.664 3.154 21.915 3.77 22.3947C4.908 23.1889 6.2623 23.6147 7.65 23.6147C9.0377 23.6147 10.392 23.1889 11.53 22.3947C12.1468 21.9165 12.9097 21.6657 13.69 21.6847C14.4708 21.6623 15.2348 21.9135 15.85 22.3947C16.9901 23.1884 18.3459 23.6138 19.735 23.6138C21.1241 23.6138 22.4799 23.1884 23.62 22.3947Z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    </a>

                                    <h1
                                        class="mt-6 text-2xl font-bold text-gray-900 dark:text-white sm:text-3xl md:text-4xl"
                                    >
                                        Welcome to Movify 🎥
                                    </h1>

                                    <p class="mt-4 leading-relaxed text-gray-500 dark:text-gray-400">
                                        Sign up for an account to start making your very own list of favorite movies!
                                    </p>

                                    <form action="#" class="mt-8 grid grid-cols-6 gap-6">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label
                                                for="FirstName"
                                                class="block text-sm font-medium text-gray-700 dark:text-gray-200"
                                            >
                                                First Name
                                            </label>

                                            <input
                                                type="text"
                                                id="FirstName"
                                                name="first_name"
                                                class="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
                                            />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label
                                                for="LastName"
                                                class="block text-sm font-medium text-gray-700 dark:text-gray-200"
                                            >
                                                Last Name
                                            </label>

                                            <input
                                                type="text"
                                                id="LastName"
                                                name="last_name"
                                                class="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
                                            />
                                        </div>

                                        <div class="col-span-6">
                                            <label
                                                for="Email"
                                                class="block text-sm font-medium text-gray-700 dark:text-gray-200"
                                            >
                                                Email
                                            </label>

                                            <input
                                                ref={emailRef}
                                                type="email"
                                                id="Email"
                                                name="email"
                                                class="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
                                            />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label
                                                for="Password"
                                                class="block text-sm font-medium text-gray-700 dark:text-gray-200"
                                            >
                                                Password
                                            </label>

                                            <input
                                                ref={passwordRef}
                                                type="password"
                                                id="Password"
                                                name="password"
                                                class="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
                                            />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label
                                                for="PasswordConfirmation"
                                                class="block text-sm font-medium text-gray-700 dark:text-gray-200"
                                            >
                                                Password Confirmation
                                            </label>

                                            <input
                                                ref={passwordConfirmRef}
                                                type="password"
                                                id="PasswordConfirmation"
                                                name="password_confirmation"
                                                class="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
                                            />
                                        </div>

                                        <div class="col-span-6">
                                        </div>

                                        <div class="col-span-6 sm:flex sm:items-center sm:gap-4">
                                            <button
                                                disabled={loading}
                                                class="inline-block shrink-0 rounded-md border border-blue-600 bg-[#1DB954] px-12 py-3 text-sm font-medium text-white transition hover:bg-transparent hover:text-blue-600 focus:outline-none focus:ring active:text-blue-500 dark:hover:bg-blue-700 dark:hover:text-white"
                                                onClick={handleSubmit}
                                            >
                                                Create an account
                                            </button>

                                            <p class="mt-4 text-sm text-gray-500 dark:text-gray-400 sm:mt-0 flex">
                                                Already have an account?
                                                <Link to="/Login">
                                                    <p className="text-gray-700 underline dark:text-gray-200 ml-1">Log in</p>
                                                </Link>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </main>
                        </div>
                    </section>


                    {/* <div className="auth-form-container bg-sky-500 items-center">
            <form onSubmit={handleSubmit}> 
                <label htmlFor="name">Full Name</label> <br></br>
                <input value={name} onChange={(e) => setName(e.target.value)} name="name" id="name" placeholder="full name"></input> <br></br>
                <label htmlfor="email">Email</label> <br></br>
                <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="sampleemail@gmail.com" id="email" name="email"></input> <br></br>
                <label htmlfor="password">Password</label> <br></br>
                <input value={pass} onChange={(e) => setPass(e.target.value)} type="password" placeholder="**********" id="password" name="password"></input> <br></br>
                <button className="border-2 py-2.5 px-2.5 my-8 bg-white border-radius: 10px rounded hover:bg-slate-300" type="submit">Sign Up</button>
            </form>
            <Link to="/Login">
            <button className="border-2 py-2.5 px-2.5 mb-8 bg-white border-radius: 10px rounded hover:bg-slate-300" onClick={() => props.onFormSwitch('login')}>Already have an account? Log in here.</button>
            </Link>
        </div> */}
                </>
                <Footer />
            </>
        
    )
}
export default Signup;